import React from 'react'

import { DirectionType, RenderAnimationType } from './lib/types'
import { TransitionCore } from './core'
import { timingFunc } from '../timing-func'

const getTransformByDirection = (
	direction: DirectionType,
	size: string | number
) =>
	({
		top: `translate(0, -${size}%)`,
		right: `translate(${size}%, 0)`,
		bottom: `translate(0, ${size}%)`,
		left: `translate(-${size}%, 0)`,
	}[direction] || null)

const getTransitionStyles = ({
	direction = 'left',
	delay = 0.5,
	time = 0.5,
	size = 30,
}: {
	direction: DirectionType
	delay: string | number
	time: string | number
	size: string | number
}) => {
	const transition = `transform ${time}s ${delay ? delay + 's' : ''} ${
		timingFunc.easeOutCubic
	}`

	return {
		entering: {
			transition,
			transform: 'translate(0, 0)',
		},
		entered: { transform: 'translate(0, 0)' },
		exiting: {
			transition,
			transform: getTransformByDirection(direction, size),
		},
		exited: { transform: getTransformByDirection(direction, size) },
	}
}

export const renderSliding: RenderAnimationType =
	({ children, ref, key, className, ...props }) =>
	state =>
		(
			<TransitionCore
				ref={ref}
				state={state}
				styles={getTransitionStyles(props)}
				bgColor={'none'}
				key={key}
				className={className}
			>
				{children}
			</TransitionCore>
		)
